import React from 'react';
import './ProductHeader.css';
import StreakElement from '../../../components/StreakElement/StreakElement';

interface ProductHeaderProps {
  streakCount?: number; // Keep for backward compatibility
}

const ProductHeader: React.FC<ProductHeaderProps> = ({ streakCount: propStreakCount }) => {
  return (
    <div className="product-header">
      <div className="product-header-content">
        <img src="/images/logo-full.png" alt="aiCourses" className="product-header-logo" />
        <StreakElement streakCount={propStreakCount} />
      </div>
    </div>
  );
};

export default ProductHeader;
